import { alertSection, placeholderSection, registerFeedbackDemos, spinnerSection, tooltipSection } from './feedback.js';
import {
  avatarSection,
  badgeSection,
  cardSection,
  detailsSection,
  fadeSection,
  formatSection,
  qrCodeSection,
  registerDisplayDemos,
  tagSection
} from './display.js';
import { breadcrumbSection, registerNavigationDemos, tabsSection, treeSection } from './navigation.js';
import { buttonSection, dropdownSection, iconButtonSection, registerActionDemos } from './actions.js';
import {
  checkboxSection,
  inputMoneySection,
  inputRowSection,
  inputSection,
  radioSection,
  textareaSection,
  toggleSection
} from './forms.js';
import { colorsSection, iconsSection, registerFoundationDemos } from './foundations.js';
import { comboboxSection, registerSelectDemos, select2Section, selectSection } from './selects.js';
import { defineDemoElement, DemoExample } from './demo-shared.js';
import { DemoApiDocs } from './demo-api-docs.js';
import { drawerSection, modalSection, popupSection, previewSection, registerOverlayDemos } from './overlays.js';
import { registerTableDemos, tableSection } from './data-table.js';
import type { DemoGroup } from './demo-shared.js';

/**
 * Defines the lab's internal elements. Called from `<component-app>`'s
 * connectedCallback rather than at module scope so importing the published
 * bundle never registers demo-* tags in a consuming app.
 */
export function registerDemoComponents() {
  defineDemoElement('demo-example', DemoExample);
  defineDemoElement('demo-api-docs', DemoApiDocs);
  registerFoundationDemos();
  registerSelectDemos();
  registerActionDemos();
  registerDisplayDemos();
  registerFeedbackDemos();
  registerOverlayDemos();
  registerNavigationDemos();
  registerTableDemos();
}

/** The sidebar: every page of the component lab, in display order. */
export const demoGroups: DemoGroup[] = [
  {
    label: 'Foundations',
    sections: [colorsSection, iconsSection]
  },
  {
    label: 'Form Controls',
    sections: [
      inputSection,
      inputMoneySection,
      inputRowSection,
      textareaSection,
      checkboxSection,
      radioSection,
      toggleSection
    ]
  },
  {
    label: 'Selects & Pickers',
    sections: [selectSection, select2Section, comboboxSection]
  },
  {
    label: 'Actions',
    sections: [buttonSection, iconButtonSection, dropdownSection]
  },
  {
    label: 'Display',
    sections: [
      tagSection,
      badgeSection,
      avatarSection,
      cardSection,
      detailsSection,
      fadeSection,
      formatSection,
      qrCodeSection
    ]
  },
  {
    label: 'Feedback',
    sections: [alertSection, spinnerSection, placeholderSection, tooltipSection, previewSection]
  },
  {
    label: 'Overlays',
    sections: [modalSection, drawerSection, popupSection]
  },
  {
    label: 'Navigation',
    sections: [tabsSection, breadcrumbSection, treeSection]
  },
  {
    label: 'Data',
    sections: [tableSection]
  }
];
